import { APIs } from "../utils/worker";
const { baseURL, bffBaseURL, delcaperURL, reportURL, pincodeServiceabilityBaseURL, TAT_URL, lockSystemServiceURL } = APIs;

const urls = {
  GET_ALL_HUBS_PENDING_AWBS: lockSystemServiceURL + "/hubops/api/all-hubs-pending-awbs",
  GET_UNBOOKED_SHIPMENTS_DETAILS: `${lockSystemServiceURL}/admin/api/unbooked-shipments-details`,
  CLEAR_UNBOOKED_SHIPMENTS: `${lockSystemServiceURL}/admin/api/unbooked-shipments/clear`,
  GET_HUB_PENDING_AWBS: `${lockSystemServiceURL}/hubops/api/hub-pending-awbs`,
  APPLY_SELECTIVE_EXTENSION: lockSystemServiceURL + "/api/extensions/selective/apply",
  GET_PINCODE: "https://api.postalpincode.in/pincode", //GET
  //GET_PINCODE_SERVICE: baseURL + "/pincode-service/pincode", //GET
  GET_PINCODE_SERVICE: baseURL + "/pincode-service/v1/pincode-mapping/dashboard/search", //GET
  GET_HUB_SERVICE: baseURL + "/pincode-service/hubs", //GET
  GET_CP_SERVICE: baseURL + "/pincode-service/cp/full-search", //GET
  GET_SEARCH_AUTOFILL: baseURL + "/pincode-service/searchAutofill", //GET
  COMMON_CP_HUB_SEARCH: baseURL + "/pincode-service/search", //GET
  GET_PINCODE_SERVICEABILITY: pincodeServiceabilityBaseURL + "/v1/pincode-serviceability",
  EXPORT_PINCODE_SERVICEABILITY: pincodeServiceabilityBaseURL + "/v1/pincode-serviceability/export",
  GET_PINCODE_AREAS: pincodeServiceabilityBaseURL + "/v1/pincode-areas",
  PINCODE_SEARCH_TRACK: pincodeServiceabilityBaseURL + "/v1/pincode-to-hub-mapping/track",
  GET_PINCODE_METADATA: pincodeServiceabilityBaseURL + "/v1/pincode-metadata",
  EXPORT_PINCODE_METADATA: pincodeServiceabilityBaseURL + "/v1/pincode-metadata/export",
  BULK_UPLOAD_PINCODE_METADATA: pincodeServiceabilityBaseURL + "/v1/pincode-metadata/bulk/upload",
  BULK_UPDATE_ZONES: pincodeServiceabilityBaseURL + "/v1/pincode-metadata/bulk-zones",
  BULK_UPLOAD_PINCODE: pincodeServiceabilityBaseURL + "/v1/pincode-serviceability/bulk/upload",
  BULK_UPLOAD_COURIER_PINCODE: pincodeServiceabilityBaseURL + "/v1/courier/bulk/upload",
  BULK_UPLOAD_ECOMM_PINCODE: pincodeServiceabilityBaseURL + "/v1/ecomm/bulk/upload",
  BULK_UPLOAD_MCN_PINCODE: pincodeServiceabilityBaseURL + "/v1/mcn/bulk/upload",
  GET_HYPERLOCAL_ZONES: pincodeServiceabilityBaseURL + "/v1/hyperlocal/zones",
  CREATE_HYPERLOCAL_ZONE: pincodeServiceabilityBaseURL + "/v1/hyperlocal/zones",
  UPDATE_HYPERLOCAL_ZONE: pincodeServiceabilityBaseURL + "/v1/hyperlocal/zones",
  TOGGLE_SERVICE_URL: pincodeServiceabilityBaseURL + "/v1/toggle-service",
  TOGGLE_ACTIVE_URL: pincodeServiceabilityBaseURL + "/v1/toggle-active",
  HYPERLOCAL_PINCODE_AREA_MASTER: pincodeServiceabilityBaseURL + "/v1/hyperlocal/pincode-area-master",
  UPDATE_TRANSIT_DAYS: pincodeServiceabilityBaseURL + "/v1/pincode-metadata",
  GET_SERVICEABILITY_STATES: pincodeServiceabilityBaseURL + "/v1/states",
  GET_SERVICEABILITY_CITIES: pincodeServiceabilityBaseURL + "/v1/cities/state/",
  CREATE_SERVICEABILITY_CITY: delcaperURL + "/serviceability/v1/cities",
  UPDATE_SERVICEABILITY_CITY: delcaperURL + "/serviceability/v1/cities",
  GET_ZONES: pincodeServiceabilityBaseURL + "/v1/zones",
  GET_BILLING_ZONES: pincodeServiceabilityBaseURL + "/v1/billing-zones",
  CREATE_ZONE: pincodeServiceabilityBaseURL + "/v1/zones",
  CREATE_BILLING_ZONE: pincodeServiceabilityBaseURL + "/v1/billing-zones",
  GET_ALL_PINCODES_SERVICEABILITY: pincodeServiceabilityBaseURL + "/v1/all-pincodes-serviceability",

  SEND_WHATSPP: "https://backend.api-wa.co/campaign/smartping/api", //POST
  UPLOAD_MANIFEST_FILE:
    baseURL + "/shipment-booking-service/v1/shipment/file-upload",
  GET_VEHICLE_ROUTES: baseURL + "/vehicle-route-service/v1/getAllRoute/SURFACE",
  // GET_VEHICLE_ROUTES: baseURL + "/route-service/v1/getRouteBypremise",
  DASHBORD_SCANNED_UNSCANNED:
    baseURL + "/shipment-booking-service/v1/operations/dashboard",
  UPDATE_SORTING_GUIDE:
    baseURL + "/sorting-service/v1/sorting-guide/premise-id",
  GET_SORTING_GUIDE_DETAIL:
    baseURL + "/sorting-service/v1/sorting-guide/sorting-guide-id/",
  GET_SORTING_NAME_BASED_DETAIL:
    baseURL + "/sorting-service/v1/sorting-guide/premise-id/",
  GET_CLIENT_DETAILS: baseURL + "/client-onboard/v1/organizations/",
  PATCH_CLIENT_DETAILS: baseURL + "/client-onboard/v1/organizations/",
  UPDATE_STAFF: baseURL + "/staff-service/v1/staff",
  VERIFY_GST: baseURL + "/publicapi-service/v1/gst/",
  PINCODE_MAPPING_PATCH: baseURL + "/client-onboard/v1/pin-code-mapping/",
  GET_CLIENT_TABLE_HO: baseURL + "/client-onboard/v1/ho/clients",
  GET_CLIENT_TABLE: baseURL + "/client-onboard/v1/cp/clients",
  GET_BANK_DETAILS_BY_IFSC: baseURL + "/staff-service/v1/ifscdetail",
  DISABLE_CLIENT: baseURL + "/client-onboard/v1/disable/",
  VERIFY_EMAIL: baseURL + "/staff-service/v1/verifykey",
  VERIFY_PHONE_NUM: baseURL + "/staff-service/v1/verifykey",
  SEND_SMS_PHONE: baseURL + "/driver-service/v1/driver/sendsms",
  GET_ALL_STAFF: baseURL + "/staff-service/v1/staff",
  GET_STAFF_ROLES: baseURL + "/staff-service/v1/staff/roles",
  GET_NOTIFICATION1: baseURL + "/notification-service/v1/getNotification/",
  GET_NOTIFICATION: baseURL + "/notification-service/v1/stream-flux",
  VIEW_NOTIFICATION: baseURL + "/notification-service/v1/updateView",

  // VERIFY_PHONE_OTP: baseURL + "/v1/driver/verifysms",
  VERIFY_PHONE_OTP: baseURL + "/driver-service/v1/driver/verifysms",

  VERIFY_EMAIL_OTP: baseURL + "/v1/driver/verifymail",
  UPLOAD_CLIENT_DOC: baseURL + "/file-service/v1/client/document",
  UPLOAD_DOC_TO_CLIENT: baseURL + "/client-onboard/v1/document/",
  ADD_CLIENT_RATE_CARD: baseURL + "/ratecard-service/v1/ratecard",
  ADD_LEAD_CLIENT_RATE_CARD: baseURL + "/lead-service-client/v1/client/lead/",

  GET_CLIENT_RATE_CARD: baseURL + "/ratecard-service/v1/ratecard/client/",
  APPROVE_CLIENT: baseURL + "/ratecard-service/v1/ratecard/",
  REJECT_CLIENT: baseURL + "/client-onboard/v1/client/decline",
  GET_RATE_CARD: baseURL + "/ratecard-service/v1/ratecard/calculate/from/",
  GET_NEW_PASSOWORD_DETAILS: baseURL + "/account-service/v1/user/",
  GET_USER_LIST: baseURL + "/account-service/v1/users",
  CREATE_NEW_PASSWORD: baseURL + "/api/users/sign-up",
  ASSIGN_HUBS: baseURL + "/account-service/v1/assign-hubs/",
  GET_HUB_LIST_WITH_FILTER: baseURL + "/premise-service/v1/premises/hub-list",
  //--Middle Mile--//
  SORT_SHIPMENT: baseURL + "/sorting-service/v1/sort-plan",
  GET_MM_ROUTE: baseURL + "/route-service/v1/getroutebypremise/",
  CREATE_BAG: baseURL + "/bagging-service/v1/bag",
  FINALISE_BAG: baseURL + "/bagging-service/v1/finalizebag/",
  GET_BAG_NUMBER: baseURL + "/bagging-service/v1/bag/bag-barcode",
  GET_ELIGIBLE_DESTINATION_HUB:
    baseURL + "/bagging-service/v1/bag/destinationhublist",
  // GET_ALL_BAGS: baseURL + "/bagging-service/v1/bag",
  GET_ALL_BAGS: baseURL + "/bagging-service/v1/bag/eligibleBags",
  DELETE_BAG_SHIPMENTS: baseURL + "/bagging-service/v1/bag",
  DELETE_BAG: baseURL + "/bagging-service/v1/bag/discard/",
  GET_BAG_DESTINATION: baseURL + "/route-service/v1/route/from/",
  POST_TRIP_GENERATE: baseURL + "/lcr-service/v1/trip/vehicle",
  GET_ALL_ROUTS: baseURL + "/route-service/v1/getroutebypremise/",
  POST_LCR: baseURL + "/lcr-service/v1/lcr",
  POST_CONSOLIDATE_LCR: baseURL + "/lcr-service/v1/consolidate/lcr",
  PATCH_CONSOLIDATED_LCR: baseURL + "/lcr-service/v1/consolidated/lcr/",
  GET_LCR_LIST: baseURL + "/lcr-service/v1/consolidated/lcr/list",
  GET_TRIP_LIST: baseURL + "/lcr-service/v1/trips",
  SEARCH_TRIP_LIST: baseURL + "/lcr-service/v1/trips/search/",
  UPDATE_TRIP_LIST: baseURL + "/lcr-service/v1/transit/lcr-trips",
  GET_TRIP_COUNT: baseURL + "/lcr-service/v1/trip/tripId",
  POST_CHECKOUT_TIME: baseURL + "/lcr-service/v1/mm/manual/",
  GET_ROUT_AND_TRIP_SCHEDULE:
    baseURL + "/surface-route-service/v1/getTripScheduled/forDate/",
  GET_ROUT_AND_TRIP_SCHEDULE_SURFACE:
    baseURL + "/surface-route-service/v1/trip/without-schedule/",
  //----//
  GET_ALL_CP_FROM_HUB: baseURL + "/manifest-service/v1/consolidated-manifest/",
  // GET_ALL_CP_FROM_HUB: baseURL + "/audit-service/v1/audit/premise",
  MANIFEST_DATE_FILTER:
    baseURL + "/manifest-service/v1/consolidated-manifest/byDate/",
  GET_CP_WISE_MANIFEST:
    baseURL + "/manifest-service/v1/manifest/status/MANIFESTED/hub/",
  GET_CP_WISE_MANIFEST_HEADER:
    baseURL + "/manifest-service/v1/manifest/status/MANIFESTED/hub/",
  GET_CP_WISE_MANIFEST_TABLE:
    baseURL + "/manifest-service/v1/manifest/status/MANIFESTED/hub/",
  AUDIT_POST: baseURL + "/audit-service/v1/web-client/audit",

  GET_SHIPMENT:
    baseURL + "/audit-service/v1/web-client/audit/shipment-details",
  AUDIT_VALIDATE: baseURL + "/audit-service/v1/audit/validate",
  BULK_AUDIT: baseURL + "/audit-service/v1/audit/bulk",
  BULK_AUDIT_VALIDATE_AND_PROCESS: baseURL + "/audit-service/v1/audit/bulk/validate-and-process",
  // https://smcs-dev.hutechweb.com/smcs-webapp/audit-service/v1/audit/shipment-details/%7BawbNo%7D

  GET_TRACKER: baseURL + "/track/v1/awbnumber/",
  GET_EWAY_TRACKER: baseURL + "/ewaybill-service/v1/eway-bills/track/",

  GET_CP_DETAILS: baseURL + "/premise-service/v1/cpDetails/",

  //LCR IN_SCAN
  GET_LCR_IN_SCAN_LIST: baseURL + "/lcr-service/v1/lcr/list/toPremise",
  GET_LCR_IN_SCAN_LIST_NEW: baseURL + "/lcr-service/v1/lcr-list/toPremise",
  SCAN_LCR_IN_SCAN_LIST: baseURL + "/lcr-service/v1/lcr",

  //LCR Bag list
  // GET_LCR_BAG_LIST: baseURL + "/bagging-service/v1/bag/update/bag/list",

  GET_LCR_SCANNED_PACKETS: baseURL + "/v1/packets/in-scan/list/",

  GET_LCR_BAG_LIST: baseURL + "/lcr-service/v1/lcr/",
  GET_LCR_SCANNED_BAGS: baseURL + "/bagging-service/v1/bag/in-scan/list",
  GET_BAGGED_CONTENTS: baseURL + "/bagging-service/v1/bag/",
  GET_PACKET_CONTENTS: baseURL + "/v1/packets/",
  GET_ROUT_BY_ID: baseURL + "/route-service/v1/getroutebyid/",
  PUT_TRIP_STATUS: baseURL + "/lcr-service/v1/trip/",
  //BAG SCAN
  UPDATE_ALL_BAGs: baseURL + "/inscan-service/v1/barcode/in-scan/",
  UPDATE_ALL_BAGS_NEW: baseURL + "/inscan-service/v2/barcode/in-scan/",
  UPDATE_ALL_PACKETS: baseURL + "/v1/packets/update/packets/status",

  GET_BAG_OPENED: baseURL + "/bagging-service/v1/bag/status/opened",

  //PRODUCT
  GET_ALL_PRODUCTS: baseURL + "/item",
  GET_PRODUCTS_BY_PREMISE: baseURL + "/item/v1/eligibility",
  GET_PRODUCT_BY_ID: baseURL + "/item/v1/",
  GET_PRODUCT_BY_ORDER_ID: baseURL + "/order/v1/orderdetailOf/",
  ADD_TO_CART: baseURL + "/cart/v1/add",
  GET_CART_DETAILS: baseURL + "/cart",
  UPDATE_DELIVERY_DETAILS: baseURL + "/cart/v1/delivery",
  REMOVE_ITEM: baseURL + "/cart/v1/remove/item/",
  UPDATE_PAYMENT_DETAILS: baseURL + "/cart/v1/payment",
  PLACE_ORDER: baseURL + "/order",
  UPDATE_ITEM_DATA: baseURL + "/cart/v1/edit-quantity",
  ORDER_LIST: baseURL + "/order/v1/orders",
  ORDER_DETAILS_BY_ID: baseURL + "/order/v1/",
  MODE_PAYMENT_DROPDOWN: baseURL + "/cart/v1/mode-of-payment",

  //SORT TO CP
  GET_CP_WISE_SORTING_DATA: baseURL + "/sort-and-out-scan",
  UPDATE_CP_WISE_SORTING_STATUS: baseURL + "/sort-and-out-scan/v1/",

  //lastMile
  GET_CP_IN_SCAN_LIST:
    baseURL + "/last-mile-manifest-service/v1/manifest/toPremise/",
  GET_MANIFEST_LIST: baseURL + "/last-mile-manifest-service/v1/manifest",
  HUB_MANIFEST_LIST: baseURL + "/sort-to-cp/v1/manifest/view/eway",
  UPDATE_LASTMILE_EWAYS: baseURL + "/sort-to-cp/v1/update-ewaybill/",

  GET_CP_MANIFEST_LIST:
    baseURL + "/last-mile-manifest-service/v1/manifest/toPremise/",
  DELETE_DRS: baseURL + "/drs-service/v1/delete/drs/",

  // /premise/areas/{premiseId}
  GET_DELIVERY_AREAS: baseURL + "/premise-service/premise/areas/",
  GET_VIEW_ALL_DELIVERY_AREAS: baseURL + "/pincode-service/v1/virtual-areas",
  CREATE_DELIVERY_AREA: baseURL + "/pincode-service/v1/virtual-area",
  GET_VIRTUAL_AREA: baseURL + "/pincode-service/v1/virtual-area/",
  DELETE_VIRTUAL_AREA: baseURL + "/pincode-service/v1/virtual-area/",
  POST_ELIGIBLE_SHIPMENTS: baseURL + "/drs-service/v1/elligible/shipments",
  POST_GENERATE_DRS: baseURL + "/drs-service/v1/drs",
  UPDATE_VIRTUAL_AREA: baseURL + "/pincode-service/v1/virtual-area/",
  GET_DELIVERY_BOY:
    baseURL + "/driver-service/v1/driver/getDeliveryBoy/details",
  GET_DRS_LIST: baseURL + "/drs-service/v1/drs/premise/list/",
  GET_SINGLE_DRS: baseURL + "/drs-service/v1/drs/",
  GET_POD: baseURL + "/drs-service/v1/drs/pod/",
  PATCH_DRS_SHIPMENT: baseURL + "/drs-service/v1/drs/",
  PENDING_DRS: baseURL + "/shipment-service/v1/shipment/pending",
  FAILED_DRS: baseURL + "/shipment-service/v1/shipment/failed/delivery",
  PENDING_DRS_SEARCH: baseURL + "/shipment-service/v1/shipment/pending",
  REMOVE_VIRTUAL_AREA: baseURL + "/premise-service/premise/area/status",
  VIEW_DRS_SEARCH: baseURL + "/drs-service/v1/search?",
  DRIVERNAME_BY_ID: baseURL + "/driver-service/v1/driver/getdriver/bydriverId/",
  VALIDATE_PINCODE_SERVICEABILITY: delcaperURL + "/serviceability/courier/vayuquick/validate",
  CREATE_PINCODE_SERVICEABILITY: delcaperURL + "/serviceability/courier/vayuquick",
  GET_VAYUQUICK_SERVICEABILITY: delcaperURL + "/serviceability/courier/vayuquick",
  UPDATE_VAYUQUICK_SERVICEABILITY: delcaperURL + "/serviceability/courier/vayuquick/booking-only",
  UPDATE_VAYUQUICK_SERVICEABILITY_ACTIVE: delcaperURL + "/serviceability/courier/vayuquick/toggle-active",
  // IN_CP_GET_TABLE: baseURL + "/last-mile/in-scan/v1//",
  // smcs-webapp/pincode-service/v1/virtual-area/{virtualAreaId}

  //PACKERING
  GET_CP_PACKETS: baseURL + "/v1/packets/eligible/packets",
  GET_HUB_PACKETS: baseURL + "/v1/packets/hub/eligible/packets",

  CREATE_PACKETS: baseURL + "/v1/packets/",
  UPDATE_PACKET: baseURL + "/v1/packets/",
  UPDATE_HUB_PACKET: baseURL + "/v1/packets/hub/",

  EWAYBILL: baseURL + "/ewaybill-service/v1/eway-bills",

  HUBEWAYBILL: baseURL + "/lcr-service/v1/lcr/ewaybill/shipments/",

  ///--Bagging Automate--///
  //NEW_TYPE_BAG_CREATE: baseURL + "/bagging-service/v1/bag/eligible-content",
  NEW_TYPE_BAG_CREATE: baseURL + "/bagging-service/v1/createbag",
  LIST_OF_BAGS: baseURL + "/bagging-service/v1/bag/bag-list",
  CREATE_EMPTY_BAG: baseURL + "/bagging-service/v1/bag/create-empty-bag",
  CHECK_VALID_BAG_NUMBER:
    baseURL + "/bagging-service/v1/bag/valid-bag-barcode/",
  ///----///
  ///--Damage Bag--///
  DAMAGE_REASON_LIST: baseURL + "/bagging-service/v1/damage/reason",
  POST_DAMAGED_BAG: baseURL + "/bagging-service/v1/damagedbag",
  POST_DAMAGED_BAG_DATA: baseURL + "/bagging-service/v1/damage/add/",
  POST_LEFT_BAG_DATA: baseURL + "/bagging-service/v1/damage/shipment",
  ///---///
  //firstMile
  CP_EWAY_BILL_TABLE: baseURL + "/manifest-service/v1/manifest/",
  CONSOLIDATE_EWAY_BILL:
    baseURL + "/ewaybill-service/v1/eway-bills/consolidate",
  EWAYBILL_UPDATE_PARTB: baseURL + "/ewaybill-service/v1/eway-bills/",
  UPDATE_TRANSPORTER_ID: baseURL + "/ewaybill-service/v1/eway-bills/transporter",
  EXTEND_EWAY_VALIDITY: baseURL + "/ewaybill-service/eWayApi_Extend_Validity",
  GET_EWAY_VALIDITY:
    baseURL + "/shipment-booking-service/v1/shipment/extend/validity",
  POST_EWAY_VALIDITY:
    baseURL + "/ewaybill-service/v1/eway-bills/extend/validity",
  UPDATED_EWAY_BILL: baseURL + "/ewaybill-service/v1/validate/eway-bills/by/",

  //HUB SORT TO CP EWAY BILL
  SORT_CP_UPDATED_EWAY_BILL:
    baseURL + "/ewaybill-service/v1/validate/eway-bills/by/lastmilemanifest/",

  QR_FOR_CHECK_IN: baseURL + "/lcr-service/v1/mm/qr/CHECK-IN/for/",
  VEHICLE_CHECKIN_CHECKOUT_REPORT:
    baseURL + "/lcr-service/v1/trip/check/In_Out/report",

  CP_OTP: baseURL + "/premise-service/v1/sendOtp ",
  VERYIFY_CP_OTP: baseURL + "/premise-service/v1/verifyOtp",

  //---Trip Scheduler--//
  GET_TRIP_SCHEDULER_LIST:
    baseURL + "/surface-route-service/v1/getTripSchedule/from/",
  GET_ALL_SCHEDULED_VECHILE:
    baseURL + "/surface-route-service/v1/getAllSchedules/forScheduling",
  DROP_SCHEDULE: baseURL + "/surface-route-service/v1/saveSchedule",
  //create Schedule
  GET_SCHEDULE_VEHICLES: baseURL + "/surface-route-service/v1/getvehicles",
  GET_SCHEDULE_ROUTES: baseURL + "/surface-route-service/v1/getRoutes",
  GET_SCHEDULE_DRIVERS: baseURL + "/surface-route-service/v1/getDrivers/",

  CREATE_SCHEDULE: baseURL + "/surface-route-service/v1/updateTripSchedule/by/",
  GET_ROUTE: baseURL + "/surface-route-service/v1/getRoute/by/",
  GET_VEHCILE_MASTERS: baseURL + "/surface-route-service/v1/getVehicleMasters",

  GET_TRIP_SCHEDULE_DATA:
    baseURL + "/surface-route-service/v1/getTripSchedules/by/",
  GET_TRIP_SCHEDULE_BY_TYPE:
    baseURL + "/surface-route-service/v1/getroute/for/",
  DELETE_TRIP_SCHEDULE:
    baseURL + "/surface-route-service/v1/deleteTripSchedule/by/",

  //--End--//

  GET_ALL_STATE: baseURL + "/pincode-service/v1/get/states",
  GET_STATES_HYPERLOCAL: delcaperURL + "/common/state-city-pincode/states",
  GET_ALL_HUBS: baseURL + "/tat-service/v1/tat/getAllHubs",
  GET_TAT_LIST: TAT_URL + "/hubtohubtat",
  GET_TAT_DETAILS: TAT_URL + "/hubtohubtat/",
  CREATE_TAT: TAT_URL + "/hubtohubtat/create",
  UPDATE_TAT: TAT_URL + "/hubtohubtat/",
  DELETE_TAT: TAT_URL + "/hubtohubtat/",
  GET_HUBS_TAT: baseURL + "/routemaster/transits",
  DOWNLOAD_HUB_TO_HUB_TAT: TAT_URL + "/hubtohubtat/data/download",
  UPLOAD_HUB_TO_HUB_TAT: TAT_URL + "/hubtohubtat/data/upload",
  LOADING_UNLOADING: baseURL + "/tat-service/v1/tat/saveData",
  GET_ALL_LOAD_UNLOAD: baseURL + "/tat-service/v1/tat/getAllLoadUnloads",
  GET_CITY: baseURL + "/premise-service/v1/cities/by/",
  GET_CITIES_BY_STATE: delcaperURL + "/common/state-city-pincode/cities-by-state",
  VEHICLE_RESTRICTION: baseURL + "/tat-service/v1/add/vehicle/restriction",
  GET_RESTRICTION_LIST: baseURL + "/tat-service/v1/vehicle/restriction/list",
  DELETE_CEHICLE_RESTRICTION:
    baseURL + "/tat-service/v1/delete/vehicle/restriction/",
  EDIT_CEHICLE_RESTRICTION:
    baseURL + "/tat-service/v1/update/vehicle/restriction/",
  UPDATE_LOAD: baseURL + "/tat-service/v1/tat/updateLoad/",
  GET_CONFIG_LIST: baseURL + "/admin-config/v1",
  GET_CONFIG_LIST_UPDATE: baseURL + "/admin-config/v1/update/",
  // UPDATE_BREAK_TIME: baseURL + "/admin-config/v1",
  AUDIT_EWAY_BILL: baseURL + "/ewaybill-service/v1/audit",
  EWAYBILL_PRINT: baseURL + "/ewaybill-service/v1/generate/consolidate/report/",
  CP_WISE_HUB_PRINT: baseURL + "/sort-to-cp/v1/print-response/",
  CP_EWAYBILL_PRINT: baseURL + "/ewaybill-service/v1/generate/lastMile/ewayreport/",
  SINGLE_EWAYBILL_PRINT: baseURL + "/ewaybill-service/v1/generate/single/report",

  AUDIT_EXCEL_DOWNLOAD:
    baseURL + "/audit-service/v1/web-client/audit-report/download",
  AUDIT_EXCEL_DOWNLOAD_HO:
    baseURL + "/audit-service/v1/web-client/audit-report/ho/download",

  GET_MIS_ROUTED_SHIPMENT: baseURL + "/inscan-service/v1/shipment/mis-routed",
  GET_EXCESS_IN_SCAN: baseURL + "/inscan-service/v1/shipment/excess-in-scan",
  // Hub onboarding
  GET_HUB_PINCODE: baseURL + "/pincode-service/v1/pincode/",
  GET_HUB_NAME_VALIDATE: baseURL + "/premise-service/v1/premise/hub-name/",
  GET_HUB_EMAIL_VALIDATE: baseURL + "/premise-service/v1/premise/hub-email/",
  GET_HUB_GST_VALIDATE: baseURL + "/premise-service/v1/premise/hub-gst/",
  GET_HUB_PINCODE_VALIDATE:
    baseURL + "/premise-service/v1/premise/hub-pincode/",
  POST_CREATE_HUB: baseURL + "/premise-service/v1/premise/hub",
  PATCH_CP_ALLOCATION: baseURL + "/premise-service/v1/premise/hub/",
  HUB_LIST_SEARCH: baseURL + "/premise-service/v1/premises/hub/search/",
  GET_EXPAND_HUB: baseURL + "/premise-service/v1/premise/hub/",
  GET_EXPAND_HUB_CP: baseURL + "/premise-service/v1/premise/hub-cp/",
  GET_EXCESS_FROM: baseURL + "/tat-service/mm-tat/from-premise/",
  PUT_UPDATE_HUB: baseURL + "/premise-service/v1/update/",
  PUT_UPDATE_HUB_FORCE_UPDATE: baseURL + "/premise-service/v1/force-update/",

  //RTO
  GET_RTO_SHIPMENT_BY_AWBNUMBER: baseURL + "/shipment-service/v1/shipment/",
  UPDATE_CASH: baseURL + "/drs-service/v1/rto/shipment/",
  PUT_RTO_SERVICE: baseURL + "/drs-service/v1/rto/",
  PUT_RATECARD_RTO: baseURL + "/ratecard-service/v1/ratecard/calculate/from/",
  GET_CPTYPE_CHECKBOX: baseURL + "/premise-service/v1/for/CP/and/type/",
  GET_TAT_DOWNLOAD_BUTTON: baseURL + "/tat-service/v1/export/mm/",

  GET_VEHICLE_FEET: baseURL + "/tat-service/v1/get/vehiclefeet/type",
  GET_CALENDER_VIEW_TRIP:
    baseURL + "/surface-route-service/v1/viewTripSchedules/by/",

  GET_TRIP_UTILIZAION: baseURL + "/lcr-service/v1/consolidated/lcr/trip/",
  DAMAGE_SHIPMENTS: baseURL + "/lcr-service/v1/getall/eliminated/lcr/contents/",
  UPDATE_DAMAGE_SHIPMENTS:
    baseURL + "/lcr-service/v1/update/eliminated/lcr/contents/by/",
  UPDATE_MISSROUTE_SHIPMENTS:
    baseURL + "/shipment-service/v1/update/mis-routed/shipment/",
  GET_LEAD_DETAILS: baseURL + "/lead-service/v1/lead",
  CLIENT_LEAD_LIST: baseURL + "/lead-service-client/v1/client/leads?",

  //lead cp onboard //
  POST_LEAD_CP_DETAILS: baseURL + "/lead-service/v1/lead",
  GET_LEAD_CP_QUOTE_TABLE: baseURL + "/lead-service/v1/quotations/",
  GET_LEAD_CP_QUOTE_BY_ID: baseURL + "/lead-service/v1/quotes/",
  GET_LEAD_CP_BILLING_CONFIG_ID:
    baseURL + "/ratecard-service/v1/billing-config/",

  UPDATE_LEAD_CP_DETAILS: baseURL + "/lead-service/v1/lead",
  GET_ALL_CP_LEADS: baseURL + "/lead-service/v1/leads",
  GET_CP_LEAD_ID: baseURL + "/lead-service/v1/lead/",
  GET_ALL_AREAS: baseURL + "/pincode-service/v1/",
  UPDATE_LEAD_CLIENT_DETAILS: baseURL + "/lead-service-client/v1/client/lead/",
  GET_ALL_CP_HUBS: baseURL + "/premise-service/v1/premises/allhub",
  //lead cp onboard //

  UPLOAD_LEAD_CLIENT_FILE: baseURL + "/file-service/v1/client/document",
  LEAD_CLIENT_DOCUMENT:
    baseURL + "/lead-service-client/v1/client/lead/document/",
  LEAD_CLIENT_LIST: baseURL + "/lead-service-client/v1/client/leads",
  LEAD_CP_LIST: baseURL + "/lead-service/v1/leads",
  LEAD_LIST: baseURL + "/lead-service/v1/leads",
  LEAD_APPROVAL: baseURL + "/lead-service/v1/lead/approval",
  GET_LEAD_CLIENT_PINCODE_MAPPING:
    baseURL + "/lead-service-client/v1/pin-code/",
  PATCH_LEAD_CLIENT_PINMAP:
    baseURL + "/lead-service-client/v1/pin-code-mapping/",
  LEAD_CP_UPLOAD: baseURL + "/publicapi-service/v1/file/", //POST

  //lead cp onboard //

  // State master
  POST_PLACE_0F_BUSINESS: baseURL + "/state-master-service/v1/statemaster",
  PUT_PLACE_0F_BUSINESS: baseURL + "/state-master-service/v1/statemaster/",
  GET_POB: baseURL + "/state-master-service/v1/statemasters",
  GET_POB_BY_ID: baseURL + "/state-master-service/v1/statemaster/",
  // State masteer

  // Quotation
  CREATE_QUOTE: baseURL + "/lead-service-client/v1/client/lead/{clientLeadId}",
  GET_CLIENT_LEAD_ID: baseURL + "/lead-service-client/v1/client/lead/",
  POST_CP_LEAD_RATE_CARD: baseURL + "/lead-service/v1/ratecard/",
  PATCH_CP_LEAD_RATE_CARD: baseURL + "/lead-service/v1/ratecard/",
  GET_QUOTE_ID: baseURL + "/lead-service-client/v1/client/lead/",
  GET_ALL_RATECARDS: baseURL + "/ratecard-service/v1/ratecards/all",
  GET_SINGLE_RATECARD: baseURL + "/ratecard-service/v1/ratecard/",
  GET_ADDED_RATECARD_CP: baseURL + "/lead-service/v1/ratecard/",
  GET_ALL_QUOTE_LIST: baseURL + "/lead-service-client/v1/client/lead/quotes/",
  GET_DEFAUT_RATE_CARD:
    baseURL + "/retail-ratecard-service/v1/ratecard/default",
  SEND_QUOTE_MAIL: baseURL + "/lead-service-client/v1/client/mail/", // POST
  GET_CLIENT_QUOTATION_DETAILS_BY_ID:
    baseURL + "/lead-service-client/v1/client/",
  UPDATE_CLIENT_RATE_CARD:
    baseURL + "/lead-service-client/v1/client/lead/ratecard/",
  // Quotation
  LEAD_CLIENT_QUOTATION_APPROVAL:
    baseURL + "/lead-service-client/v1/client/approval/",
  // GET_RATE_CARD_DATA_ID: baseURL + "/ratecard-service/v1/ratecard/",

  //
  GST_UPLOAD: baseURL + "/publicapi-service/v1/file/gstCertificate",
  AUDIT_LIST: baseURL + "/audit-service/v1/web-client/audit-report/",
  AUDIT_SEARCH: baseURL + "/audit-service/v1/web-client/audit-report/search",

  GET_DEFAULT_RETAL_RATECARD: baseURL + "/retail-ratecard-service/v1/ratecard/",
  GET_RETAIL_EXISTING_RATECARD:
    baseURL + "/retail-ratecard-service/v1/ratecards",
  GET_DETAILS: baseURL + "/lead-service/v1/",

  GET_RETAIL_EXISTING_RATECARD_BY_ID:
    baseURL + "/retail-ratecard-service/v1/ratecard/",
  GET_RATE_CARD_APPROVAL: baseURL + "/lead-service/v1/lead/approval",

  //ROUTE SERVICES
  CREATE_ROUTE: baseURL + "/route-service/v1/route/from/", //HO

  GET_ALL_ROUTE: baseURL + "/route-service/v1/routes/", //HO
  CREATE_V_ROUTE: baseURL + "/vehicle-route-service/v1/createroute", //HUB
  GET_ALL_V_ROUTE: baseURL + "/vehicle-route-service/v1/routes/", //HUB
  DELETE_V_ROUTE: baseURL + "/vehicle-route-service/v1/route/", //HUB
  UPDATE_MASTER_VEHICLE: baseURL + "/surface-route-service/v1/updateSchedule/byId/",
  UPDATE_V_ROUTE: baseURL + "/vehicle-route-service/v1/update-route/", //HO
  UPLOAD_VEHICLE_ROUTE: baseURL + "/vehicle-route-service/v1/upload", //Upload Vehicle Route
  //

  //Client Approvals

  GET_CLIENT_APPROVAL_LIST:
    baseURL + "/lead-service-client/v1/client/lead/quotes", // GET
  GET_CLIENT_APPROVAL_PINCODE_MAP:
    baseURL + "/pincode-service/v1/pincode-mapping/lead/pin-code-mapping/", // GET
  GET_CLIENT_APPROVAL_RATECARD:
    baseURL + "/lead-service-client/v1/client/ratecard/", //GET
  //Client Approvals

  NEW_INSCAN: baseURL + "/inscan-service/v1/in-scan", //GET
  //LCR
  GET_ALL_VEHICLE_ROUTS: baseURL + "/vehicle-route-service/v1/getAllRoute/", //GET
  GET_ALL_VEHICLES: baseURL + "/vehicle-service/v1/availableVehicles", //GET
  POST_ELIGIBLE_BAGS: baseURL + "/out-scan-service/v1/trip/", //POST
  POST_TRIP_ID: baseURL + "/lcr-service/v1/trips", //POST
  GET_VIEW_TRIP: baseURL + "/lcr-service/v1/consolidated/lcr/trip/", //GET
  LOCK_LCR: baseURL + "/lcr-service/v1/", //PUT
  GET_DRIVER_LIST: baseURL + "/driver-service/v1/driver/getdriver/", //GET
  PUT_DRIVER_DETAILS: baseURL + "/vehicle-service/v1/vehicle/", //PUT
  GET_ALL_LCR_TRIPS: baseURL + "/lcr-service/web/v1/trip-list", // GET
  LOCK_TRIP_LCR: baseURL + "/lcr-service/web/v1/update-vehicle-lcr-status/", // PUT with tripID & status
  TRIP_BASED_SHIPMENT_REPORT: baseURL + "/lcr-service/web/v1/",
  REMOVE_BAG_FROM_LCR: baseURL + "/lcr-service/web/v1/lcr/delete-bag/",
  //LCR

  //--SORT TO CP--//
  SORT_LAST_MILE_TYPES: baseURL + "/sort-to-cp/v1/types",
  GET_ELIGIBLE_OUTSCAN_CP: baseURL + "/sort-to-cp/v1/eligible/outscan/cp",
  GET_SORT_LAST_MILE_ELIGIBLE_DATA: baseURL + "/sort-to-cp/v1/eligible/outscan",
  GENERATE_MANIFEST: baseURL + "/sort-to-cp/v1/manifest",
  ALL_MANIFEST_LIST: baseURL + "/sort-to-cp/v1/manifest/view/",
  MANIFEST_CP_LIST: baseURL + "/sort-to-cp/v1/manifest/cp-list/",
  CP_WISE_MANIFEST: baseURL + "/sort-to-cp/v1/manifest/view/cp",
  THREE_PL_WISE_MANIFEST: baseURL + "/sort-to-cp/v1/manifest/view/3pl",
  //----//

  //----------------CP KYC ----------------------//
  POST_WO_GST: baseURL + "/kyc-verification/v1/wallet/onboard", //POST
  POST_GST: baseURL + "/kyc-verification/v1/wallet/onboard", //POST
  UPDATE_CP_KYC: baseURL + "/kyc-verification/v1/wallet/update/", // PATCH
  VERIFY_KYC_OTP: baseURL + "/kyc-verification/v1/wallet/verify-otp/", // PATCH;
  CP_KYC_SAVE: baseURL + "/kyc-verification/v1/customer/save-kyc", // POST
  GET_KYC_DETAILS: baseURL + "/premise-service/v1/premise-wallet/details", //GET

  //----------------Billing Config and Rate card list-----------//
  GET_RATE_CARD_LIST: baseURL + "/ratecard-service/v1/billing-configs",
  GET_BILLING_NAME_TYPE_CYCLE: baseURL + "/ratecard-service/v1/billing-config",
  GET_CP_RATECARD:
    baseURL + "/ratecard-service/v1/billing-config/ratecard-type/",

  ///-----------------RETAIL BOOKING NEW------------------------///
  CHECK_PIN_CODE_SERVICEABILITY:
    bffBaseURL + "/v1/bff/serviceability/?pinCode=",
  FETCH_RATE_CARD_CP: baseURL + "/ratecard-service/v1/ratecard/calculate/from/",
  GET_CP_TAT_SERVICE: baseURL + "/tat-service/v1/tat/from/",
  GET_DESTINATION_PREMISE_ID:
    baseURL + "/premise-service/v1/premise/areas/premise-id/",
  POST_RETAIL_BOOKING: baseURL + "/shipment-booking-service/v1/cashbooking",

  //Address
  GET_RETAIL_DOCUMENT_DETAILS:
    baseURL + "/shipment-booking-service/v1/shipments/",
  UPDATE_RETAIL_DOCUMENT_DETAILS:
    baseURL + "/shipment-booking-service/v1/cashbooking/",
  GET_CHECK_GST_NUMBER: baseURL + "/premise-service/v1/premise/gst/",

  VALIDATE_PUBLIC_GST_NUMBER: baseURL + "/publicapi-service/v1/gst/",

  // UPDATE_RETAIL_DOCUMENT_DETAILS: baseURL + "/shipment-service/v1/shipment/",
  ///-----------------------------------------------------------///

  ///-----------------Credite Booking------------------------///
  GET_CLIENT_LIST: baseURL + "/client-onboard/v1/cp/clients",
  GET_DEPARTMENT_LIST: baseURL + "/client-onboard/v1/organizations/",
  GET_CONTENTDISCRIPTIN_LIST: baseURL + "/shipment-booking-service/v1/content",
  POST_CREDIT_DATA: baseURL + "/shipment-booking-service/v1/account-booking",
  ADDRESS_PINCODE: baseURL + "/pincode-service/v1/pincode/",
  // GET_SERVICEABILITY_CHECK: bffBaseURL + "/v1/bff/serviceability/?pinCode=",
  RETURN_ADDRESS:
    baseURL +
    "/shipment-booking-service/v1/shipment/accountbooking/return-address/",
  UPDATE_ALL_BAGS_NEW1: baseURL + "/inscan-service/v1/mob-lcr-in-scan",
  EXIT_TRIP: baseURL + "/lcr-service/web/v1/exit-trip/",
  GET_RECENT_BOOKING: baseURL + "/shipment-booking-service/v1/recent-booking/",
  GET_ALL_BOOKING_STATUS:
    baseURL + "/shipment-service/v1/shipment-operation/allstatus",

  GET_RECIVER_NAME_ADDRESS:
    baseURL + "/shipment-booking-service/v1/shipment/userDetails/",

  //------------------------DISCOUNT-------------------------//
  GET_DISCOUNT_ELIGIBLE_LIST:
    baseURL + "/shipment-booking-service/v1/booking-discount-list",
  GET_DISCOUNT_LIST: baseURL + "/shipment-booking-service/v1/discount-list",
  APPLY_DISCOUNT: baseURL + "/shipment-booking-service/v1/apply-discount",
  GET_DISCOUNT_SENDERS_NAMES:
    baseURL + "/shipment-booking-service/v1/sendernames/",

  GET_DISCOUNT_PERCENT:
    baseURL + "/shipment-booking-service/v1/shipment/config",

  POST_NEW_RETAIL_BOOKING: baseURL + "/shipment-booking-service/v2/cashbooking",

  CHECK_CHILD_AWB_USED:
    baseURL + "/shipment-booking-service/v1/check-childawbnumber/",
  YESTARDAY_DATA: baseURL + "/hubops-report-service/v1/yeterday/report",

  CHECK_LOCAL: baseURL + "/pincode-service/v1/pincode-mapping/rate/",

  HUB_LOCK_MANIFEST: baseURL + "/sort-to-cp/v1/manifest/",

  SHIPMENT_TRACKER: baseURL + "/tracking-service/v1/hubops-tracking/",

  //Exceptions Reports
  GET_EXCEPTION_REPORT_DATA: baseURL + "/TableData",
  GET_EXCEPTION_ACTIONS_DATA: baseURL + "/actionData",
  POST_EXCEPTION_REPORT_DATA: baseURL + "/POST",
  PUT_EXCEPTION_REPORT_DATA: baseURL + "/PUT",

  UPDATE_EXCEPTION_REPORT_BAG: baseURL + "/bagging-service/v1/report/damage/",

  GET_HUB_LISTS: baseURL + "/premise-service/v1/hub-list",
  REMOVE_EMPTY_LCR: baseURL + "/lcr-service/web/v1/discard/trip/",

  //HUB PINCODE MAPPING 
  GET_ALL_PINCODE_HUB_WISE_MAPPING: baseURL + "/premise-service/v1/pincode-premise",
  ADD_PINCODE_HUB_WISE_MAPPING: baseURL + "/premise-service/v1/pincode-premise/create",
  DELETE_PINCODE_HUB_WISE_MAPPING: baseURL + "/premise-service/v1/pincode-premise/delete",

  //HUB TO CP MAster
  HUB_TO_CP_MASTER_FOR_BAGGING: baseURL + "/pincode-service/v1/bagging-cp",
  HUB_TO_CP_LINKING_REMOVE: baseURL + "/premise-service/v1/premise/remove/hub-cp-details/",

  //GET CP LIST
  GET_CP_LIST: baseURL + "/premise-service/v1/premises/cp-list/",

  //Booked vs Audited Report
  GET_BOOKED_VS_AUDITED_REPORT: `${reportURL}/report-service/api/v1/report/booking-audited-report`,
  GET_BOOKED_VS_AUDITED_DOWNLOAD_REPORT: `${reportURL}/report-service/api/v1/report/booking-audited-report/download`,

  //Audited Details Report
  GET_AUDITED_DETAILS_REPORT: `${reportURL}/report-service/api/total-audited-report`,
  GET_AUDITED_DETAILS_DOWNLOAD_REPORT: `${reportURL}/report-service/api/total-audited-report/download`,

  //Total Bookings Audit Report
  GET_TOTAL_BOOKINGS_AUDIT_REPORT: `${reportURL}/report-service/api/total-bookings-audit-report`,
  GET_TOTAL_BOOKINGS_AUDIT_DOWNLOAD_REPORT: `${reportURL}/report-service/api/total-bookings-audit-report/download`,
  //Booking Status Report
  GET_BOOKING_STATUS_REPORT: `${reportURL}/report-service/api/v1/report/booking-status-report`,
  GET_BOOKING_STATUS_DOWNLOAD_REPORT: `${reportURL}/report-service/api/v1/report/booking-status-report/download`,

  //Booking vs first inscan Report
  GET_BOOKING_VS_INSCAN_OUTSCAN_REPORT: `${reportURL}/report-service/api/v1/report/booking-vs-inscan-outscan`,
  GET_BOOKING_VS_INSCAN_OUTSCAN_DOWNLOAD_REPORT: `${reportURL}/report-service/api/v1/report/booking-vs-inscan-outscan/download`,

  // Inscan vs Audit Report
  GET_INSCAN_VS_AUDIT_REPORT: `${reportURL}/report-service/api/v1/report/hubops-inscan-audit`,

  // Inscan vs Audit Clickable Reports
  GET_TOTAL_ASSIGNED_CLICKABLE_REPORT: `${reportURL}/report-service/api/totalassignedclickable`,
  GET_INSCANNED_AT_TRANSIT_CLICKABLE_REPORT: `${reportURL}/report-service/api/inscanned_at_transit_clickable`,
  GET_INSCANNED_CLICKABLE_REPORT: `${reportURL}/report-service/api/inscanned_clickable`,
  GET_HUB_INSCANNED_CLICKABLE_REPORT: `${reportURL}/report-service/api/hub_inscanned_clickable`,
  GET_TOTAL_AUDITED_CLICKABLE_REPORT: `${reportURL}/report-service/api/totalauditedclickable`,

  GET_INSCANNED_SHIPMENTS_CLICKABLE_REPORT: `${reportURL}/report-service/api/v1/report/inscanned-shipments-clickable`,
  DOWNLOAD_INSCANNED_SHIPMENTS_CLICKABLE_REPORT: `${reportURL}/report-service/api/v1/report/inscanned-shipments-clickable/download`,
  GET_AUDITED_SHIPMENTS_CLICKABLE_REPORT: `${reportURL}/report-service/api/v1/report/audited-shipments-clickable`,
  DOWNLOAD_AUDITED_SHIPMENTS_CLICKABLE_REPORT: `${reportURL}/report-service/api/v1/report/audited-shipments-clickable/download`,
  GET_NOT_AUDITED_SHIPMENTS_CLICKABLE_REPORT: `${reportURL}/report-service/api/v1/report/not-audited-shipments-clickable`,
  DOWNLOAD_NOT_AUDITED_SHIPMENTS_CLICKABLE_REPORT: `${reportURL}/report-service/api/v1/report/not-audited-shipments-clickable/download`,

  GET_HUB_AUDIT_ENTRY_REPORT: `${reportURL}/report-service/api/v1/report/hub-audit-entry-report`,
  DOWNLOAD_HUB_AUDIT_ENTRY_REPORT: `${reportURL}/report-service/api/v1/report/hub-audit-entry-report/download`,

  //Incoming Bag Report
  GET_INCOMING_BAG_REPORT: `${reportURL}/report-service/api/v1/report/incoming-bag-report`,
  GET_INCOMING_BAG_DOWNLOAD_REPORT: `${reportURL}/report-service/api/v1/report/incoming-bag-report/download`,

  //Outgoing Bag Report
  GET_OUTGOING_BAG_REPORT: `${reportURL}/report-service/api/v1/report/outgoing-bag-report`,
  GET_OUTGOING_BAG_DOWNLOAD_REPORT: `${reportURL}/report-service/api/v1/report/outgoing-bag-report/download`,

  //Fast Track Report
  GET_FASTTRACK_REPORT: `${reportURL}/report-service/api/v1/report/fastrack-report`,
  GET_FASTTRACK_DOWNLOAD_REPORT: `${reportURL}/report-service/api/v1/report/fastrack/download`,

  //Delivery MIS Report
  GET_DELIVERY_MIS_REPORT: `${delcaperURL}/drs-service/drs/report`,
  DOWNLOAD_DELIVERY_MIS_REPORT: `${delcaperURL}/drs-service/drs/report/download`,

  // Report URLs
  GET_CONTROL_TOWER_REPORT: `${baseURL}/report-service/controltower-report-status`,
  GET_CONTROL_TOWER_NEW_REPORT: `${reportURL}/report-service/api/control-tower`,
  DOWNLOAD_CONTROL_TOWER_NEW_REPORT: `${reportURL}/report-service/api/control-tower/download`,
  GET_CONTROL_TOWER_STATUS_LIST: `${reportURL}/report-service/api/v1/report/control-tower-status-list`,
  GET_CONTROL_TOWER_SERVICE_TYPE_LIST: `${reportURL}/report-service/api/v1/report/control-tower-service-type-list`,
  GET_CONTROL_TOWER_CURRENT_HUB_LIST: `${reportURL}/report-service/api/v1/report/control-tower-current-hub-list`,

  GET_CONTROL_TOWER_A3: `${reportURL}/report-service/api/v1/report/control-tower-a3`,
  GET_CONTROL_TOWER_REFRESH_SCHEDULE: `${reportURL}/report-service/api/v1/dynamic-data/refresh-schedule-control-tower`,
  GET_CONTROL_TOWER_HISTORICAL_REFRESH_SCHEDULE: `${reportURL}/report-service/api/v1/dynamic-data/refresh-schedule-control-tower-historical`,
  GET_CONTROL_TOWER_HISTORICAL_DATE_RANGE: `${reportURL}/report-service/api/v1/dynamic-data/date-range-control-tower-historical`,
  GET_CONTROL_TOWER_CURRENT_DATE_RANGE: `${reportURL}/report-service/api/v1/dynamic-data/date-range-control-tower-current`,
  GET_DELIVERY_REPORTS_REFRESH_SCHEDULE: `${reportURL}/report-service/api/v1/dynamic-data/refresh-schedule-delivery-reports`,
  DOWNLOAD_CONTROL_TOWER_A3: `${reportURL}/report-service/api/v1/report/control-tower-a3/download`,

  GET_CONTROL_TOWER_HUB_REPORT: `${reportURL}/report-service/api/v1/outgoingshipment-report`,
  DOWNLOAD_CONTROL_TOWER_HUB_REPORT: `${reportURL}/report-service/api/v1/outgoingshipment-report/download`,

  // Incoming Shipment Pendency Report
  GET_INCOMING_SHIPMENT_PENDENCY_REPORT: `${reportURL}/report-service/api/v1/incomingshipmentcontroltower`,
  DOWNLOAD_INCOMING_SHIPMENT_PENDENCY_REPORT: `${reportURL}/report-service/api/v1/incomingshipmentcontroltower/download`,

  // VayuQuickPro Report
  GET_VAYUQUICK_PRO_REPORT: `${reportURL}/report-service/api/v1/report/vayuquick-report`,
  DOWNLOAD_VAYUQUICK_PRO_REPORT: `${reportURL}/report-service/api/v1/report/vayuquick-report/download`,

  GET_DRS_REPORT: `${delcaperURL}/drs-service/drs/report`,

  //MCN List 

  GET_MCN_LIST: `${baseURL}/shipment-booking-service/v1/shipments/mcn`,
  GET_MCN_LIST_REPORT: `${reportURL}/report-service/api/mcn`,
  GET_MCN_DOWNLOAD_REPORT: `${reportURL}/report-service/api/mcn/download`,

  // Force Bag Report
  GET_FORCE_BAG_REPORT: `${reportURL}/report-service/api/force-bag`,
  DOWNLOAD_FORCE_BAG_REPORT: `${reportURL}/report-service/api/force-bag/download`,

  // Force Shipment Scan Report
  GET_FORCE_SHIPMENT_REPORT: `${reportURL}/report-service/api/force-shipment`,
  DOWNLOAD_FORCE_SHIPMENT_REPORT: `${reportURL}/report-service/api/force-shipment/download`,

  // Force Bag Attempt Shipment  Count
  GET_FORCE_ATTEMPT_BAG_REPORT_COUNT: `${reportURL}/report-service/api/force-bag-attempted-report`,
  DOWNLOAD_FORCE_ATTEMPT_BAG_REPORT_COUNT: `${reportURL}/report-service/api/force-bag-attempted-report/download`,
  GET_FORCE_ATTEMPT_SHIPMENT_DETAILS: `${reportURL}/report-service/api/clickable-force-bag-attempted-shipments`,
  DOWNLOAD_FORCE_ATTEMPT_SHIPMENT_DETAILS: `${reportURL}/report-service/api/clickable-force-bag-attempted-shipments/download`,
  GET_INCOMING_OUTGOING_SHIPMENT_DETAILS: `${reportURL}/report-service/api/clickable-incoming-outgoing-bag-report`,
  DOWNLOAD_INCOMING_OUTGOING_SHIPMENT_DETAILS: `${reportURL}/report-service/api/clickable-incoming-outgoing-bag-report/download`,

  //DP Onboarding
  DP_ON_BOARDING: `${bffBaseURL}/delivery-partner`,
  DP_LIST: `${bffBaseURL}/delivery-partner`,
  DP_DETAILS: `${bffBaseURL}/delivery-partner`, // GET /{id} for details
  DP_UPDATE_DETAILS: `${bffBaseURL}/delivery-partner`, // PUT /{id} for update

  //Incoming LCR Report
  GET_HUB_AUDIT_REPORT: `${reportURL}/report-service/api/v1/report/hub-audit`,
  GET_INCOMING_LCR_REPORT: `${reportURL}/report-service/api/v1/report/incoming-lcr-report`,
  GET_LCR_TALLY_REPORT: `${reportURL}/report-service/api/v1/report/lcr-tally`,
  GET_OUTGOING_LCR_REPORT: `${reportURL}/report-service/api/v1/report/outgoing-lcr-report`,
  GET_DELIVERY_STATUS_REPORT: `${reportURL}/report-service/api/v1/report/delivery-status-report`,
  GET_OUTSCAN_CP_INSCAN_REPORT: `${reportURL}/report-service/api/hub-outscan-vs-cp-inscan-report`,
  GET_OUTSCAN_BY_HUB_TO_BRANCH: `${reportURL}/report-service/api/v1/outscanbyhubtobranchclikable`,
  DOWNLOAD_OUTSCAN_BY_HUB_TO_BRANCH: `${reportURL}/report-service/api/v1/outscanbyhubtobranchclikable/download`,
  GET_INSCAN_BY_CP: `${reportURL}/report-service/api/v1/inscanbycp`,
  DOWNLOAD_INSCAN_BY_CP: `${reportURL}/report-service/api/v1/inscanbycp/download`,
  GET_INSCAN_BY_OTHER_CP: `${reportURL}/report-service/api/v1/inscanbyothercp`,
  DOWNLOAD_INSCAN_BY_OTHER_CP: `${reportURL}/report-service/api/v1/inscanbyothercp/download`,
  GET_DELIVERY_SCAN_BY_BRANCH: `${reportURL}/report-service/api/v1/deliveryscanbybranch`,
  DOWNLOAD_DELIVERY_SCAN_BY_BRANCH: `${reportURL}/report-service/api/v1/deliveryscanbybranch/download`,
  DOWNLOAD_INCOMING_LCR_REPORT: `${reportURL}/report-service/api/v1/incoming-lcr/download`,
  DOWNLOAD_LCR_TALLY_REPORT: `${reportURL}/report-service/api/v1/report/lcr-tally/download`,
  DOWNLOAD_OUTGOING_LCR_REPORT: `${reportURL}/report-service/api/v1/outgoing-lcr/download`,
  DOWNLOAD_DETAILS_BAG_REPORT: `${reportURL}/report-service/api/bag/detail-view/download`,
  DOWNLOAD_DETAILS_SHIPMENT_REPORT: `${reportURL}/report-service/api/shipment/detail-view/download`,
  DOWNLOAD_DDELIVERY_STATUS_REPORT: `${reportURL}/report-service/api/v1/report/delivery-status-report/download`,
  DOWNLOAD_OUTSCAN_CP_INSCAN_REPORT: `${reportURL}/report-service/api/hub-outscan-vs-cp-inscan-report/download`,
  GET_SAME_DAY_DELIVERY_CLICKABLE_REPORT: `${reportURL}/report-service/api/v1/samedaydelivery`,
  DOWNLOAD_SAME_DAY_DELIVERY_CLICKABLE_REPORT: `${reportURL}/report-service/api/v1/samedaydelivery/download`,

  GET_NOT_INSCANNED_BY_CP_CLICKABLE: `${reportURL}/report-service/api/v1/not-inscanned-by-cp-clickable`,
  DOWNLOAD_NOT_INSCANNED_BY_CP_CLICKABLE: `${reportURL}/report-service/api/v1/not-inscanned-by-cp-clickable/download`,

  // DRS By Other CP
  GET_DRS_BY_OTHER_CP: `${reportURL}/report-service/api/v1/drsbyothercp`,
  DOWNLOAD_DRS_BY_OTHER_CP: `${reportURL}/report-service/api/v1/drsbyothercp/download`,

  // Same Day Delivery By Other CP
  GET_SAME_DAY_DELIVERY_BY_OTHER_CP: `${reportURL}/report-service/api/v1/samedaydeliverybyothercp`,
  DOWNLOAD_SAME_DAY_DELIVERY_BY_OTHER_CP: `${reportURL}/report-service/api/v1/samedaydeliverybyothercp/download`,

  DOWNLOAD_HUB_AUDIT_REPORT: `${reportURL}/report-service/api/v1/report/hub-audit/download`,
  //REGEX_PATTERN
  GET_REGEX_PATTERN: `${baseURL}/api/v1/global-config/REGEX_PATTERN/ALPHANUMERIC `,

  BAG_DETAIL_VIEW: `${baseURL}/lcr-service/web/bag/detail-view `,
  SHIPMENT_DETAIL_VIEW: `${baseURL}/lcr-service/web/shipment/detail-view `,

  //shipment tracking

  GET_SHIPMENT_TRACKING: `${bffBaseURL}/inscan-service/tracking`,
  GET_SHIPMENT_TRACKING_V2: `${delcaperURL}/tracking/v2/`,
  BAG_DETAIL_VIEW_LCR: `${reportURL}/report-service/api/bag/detail-view`,
  SHIPMENT_DETAIL_VIEW_LCR: `${reportURL}/report-service/api/shipment/detail-view`,
  IN_BAG_SHIPMENT_DETAIL_VIEW_LCR: `${reportURL}/report-service/api/in-bag-shipment/detail-view`,

  //Excess Inscan Report
  GET_EXCESS_INSCAN_REPORT: `${reportURL}/report-service/api/v1/report/excess-inscan`,
  GET_EXCESS_INSCAN_ENHANCED_REPORT: `${reportURL}/report-service/api/excess-inscan-enhanced`,
  DOWNLOAD_EXCESS_INSCAN_ENHANCED_REPORT: `${reportURL}/report-service/api/excess-inscan-enhanced/download`,
  GET_CP_OUTSCAN_VS_HUB_INSCAN_REPORT: `${reportURL}/report-service/api/v1/report/cp-outscan-vs-hub-inscan`,
  DOWNLOAD_CP_OUTSCAN_VS_HUB_INSCAN_REPORT: `${reportURL}/report-service/api/v1/report/cp-outscan-vs-hub-inscan/download`,

  // Hub Inscan Clickable Report
  GET_HUB_INSCAN_CLICKABLE_REPORT: `${reportURL}/report-service/api/hubinscanreportclickable`,
  DOWNLOAD_HUB_INSCAN_CLICKABLE_REPORT: `${reportURL}/report-service/api/hubinscanreportclickable/download`,

  // CP Outscan Clickable Report
  GET_CP_OUTSCAN_CLICKABLE_REPORT: `${reportURL}/report-service/api/cpoutscanreportclickable`,
  DOWNLOAD_CP_OUTSCAN_CLICKABLE_REPORT: `${reportURL}/report-service/api/cpoutscanreportclickable/download`,

  //Eway Bill Report
  GET_EWAY_BILL_REPORT: `${reportURL}/report-service/api/v1/report/eway`,
  DOWNLOAD_EWAY_BILL_REPORT: `${reportURL}/report-service/api/v1/report/eway/download`,

  //Inscan Report
  GET_INSCAN_REPORT: `${reportURL}/report-service/api/inscan-report`,
  DOWNLOAD_INSCAN_REPORT: `${reportURL}/report-service/api/inscan-report/download`,

  //Smile Label Generation
  GET_SMILE_LABEL_GENERATION: `${bffBaseURL}/inscan-service/label/ `,

  //API Log
  GET_API_LOGS: `${baseURL}/api-log-service/v1/logs`,
  GET_API_LOG_SERVICES: `${baseURL}/api-log-service/v1/services`,
  GET_API_LOG_BY_ID: `${baseURL}/api-log-service/v1/logs/`,

  //Training Videos
  GET_TRAINING_VIDEOS: "https://dispatchapis.delcaper.com/delivery-agent-service/api/v1/delivery-agent/training-videos",

  // Exception Status (Delcaper)
  EXCEPTION_UPDATE_REQ_COURIER: `${delcaperURL}/drs-service/exceptionUpdateReq/courier`, // GET ?hubId=
  EXCEPTION_STATUS_COURIER: `${delcaperURL}/drs-service/exception-status/courier`, // PATCH

  //Wrong Sorting Report
  GET_WRONG_SORTING_REPORT: `${reportURL}/report-service/api/wrong-sorting`,
  DOWNLOAD_WRONG_SORTING_REPORT: `${reportURL}/report-service/api/wrong-sorting/download`,

  //Booking vs Delivery Report
  GET_BOOKING_VS_DELIVERY_REPORT: `${reportURL}/report-service/api/booking-vs-delivery-report`,
  DOWNLOAD_BOOKING_VS_DELIVERY_REPORT: `${reportURL}/report-service/api/booking-vs-delivery-report/download`,

  //Hubwise Shipments Inscan vs Outscan Report
  GET_HUBWISE_SHIPMENTS_INSCAN_VS_OUTSCAN_REPORT: `${reportURL}/report-service/api/hubwise-shipments-inscan-vs-outscan-report`,
  GET_SHIPMENT_INSCAN_CLICKABLE_REPORT: `${reportURL}/report-service/api/shipmentinscanclickablereport`,
  GET_SHIPMENT_OUTSCAN_CLICKABLE_REPORT: `${reportURL}/report-service/api/shipmentoutscanclickablereport`,
  GET_SHIPMENT_PENDING_CLICKABLE_REPORT: `${reportURL}/report-service/api/shipmentpendingclickablereport`,
  DOWNLOAD_SHIPMENT_INSCAN_CLICKABLE_REPORT: `${reportURL}/report-service/api/shipmentinscanclickablereport/download`,
  DOWNLOAD_SHIPMENT_OUTSCAN_CLICKABLE_REPORT: `${reportURL}/report-service/api/shipmentoutscanclickablereport/download`,
  DOWNLOAD_SHIPMENT_PENDING_CLICKABLE_REPORT: `${reportURL}/report-service/api/shipmentpendingclickablereport/download`,
  DOWNLOAD_HUBWISE_SHIPMENTS_INSCAN_VS_OUTSCAN_REPORT: `${reportURL}/report-service/api/hubwise-shipments-inscan-vs-outscan-report/download`,

  //Finalized Bags Pending Outscan Report
  GET_FINALIZED_BAGS_PENDING_OUTSCAN_REPORT: `${reportURL}/report-service/api/finalized-bags-pending-outscan-report`,
  DOWNLOAD_FINALIZED_BAGS_PENDING_OUTSCAN_REPORT: `${reportURL}/report-service/api/finalized-bags-pending-outscan-report/download`,

  //MCN Dashboard Statistics
  GET_MCN_DASHBOARD_STATISTICS: `${bffBaseURL}/inscan-service/mcn-dashboard-statistics`,

  //Non-FT Premium Bookings Report
  GET_NON_FT_PREMIUM_BOOKINGS_REPORT: `${reportURL}/report-service/api/v1/report/non-ft-premium-bookings`,
  DOWNLOAD_NON_FT_PREMIUM_BOOKINGS_REPORT: `${reportURL}/report-service/api/v1/report/non-ft-premium-bookings/download`,

  //Inscanned Bags Report
  GET_INSCANNED_BAGS_REPORT: `${reportURL}/report-service/api/v1/report/inscan-bags`,
  DOWNLOAD_INSCANNED_BAGS_REPORT: `${reportURL}/report-service/api/v1/report/inscan-bags/download`,

  // Superset Guest Token
  FETCH_GUEST_TOKEN: `${reportURL}/a3/fetch-guest-token`,
  NEW_GET_CP_LIST: `${baseURL}/premise-service/v1/premises/allcp`,

  // Director Dashboard APIs
  GET_HUBOPS_DATA: `${reportURL}/report-service/api/v1/dashboard/hubops-data`,
  GET_HUB_MANAGER_DASHBOARD: `${reportURL}/report-service/api/v1/report/hub-manager-dashboard`,
  GET_HUB_OVERVIEW_DASHBOARD: `${reportURL}/report-service/api/v1/report/hub-overview-dashboard`,
  GET_PIE_CHART_HUB_MANAGER_OVERVIEW: `${reportURL}/report-service/api/v1/report/pie-chart-hub-manager-overview`,
  GET_DASHBOARD_SUMMARY: `${reportURL}/report-service/api/v1/report/dashboard-summary`,
  GET_CLICKABLE_HUB_MANAGER_DASHBOARD: `${reportURL}/report-service/api/v1/report/clickable-hub-manager-dashboard`,
  GET_CLICKABLE_HUB_MANAGER_DASHBOARD_DOWNLOAD: `${reportURL}/report-service/api/v1/report/clickable-hub-manager-dashboard/download`,
  GET_SHIPMENT_BUSINESS_DATA: `${reportURL}/report-service/api/v1/dashboard/shipment-business-data`,
  GET_DELIVERY_DATA: `${reportURL}/report-service/api/v1/dashboard/delivery-data`,
  GET_BUSINESS_STATISTICS_PREVIOUS_DAY: `${reportURL}/report-service/api/v1/dashboard/business-statistics/previous-day`,
  GET_PIE_CHART_HUB_MANAGER_OVERVIEW_CLICKABLE: `${reportURL}/report-service/api/v1/report/pie-chart-hub-manager-overview-clickable`,
  DOWNLOAD_PIE_CHART_HUB_MANAGER_OVERVIEW_CLICKABLE: `${reportURL}/report-service/api/v1/report/pie-chart-hub-manager-overview-clickable/download`,
  GET_TOTAL_AVAILABLE_SHIPMENTS_CLICKABLE: `${reportURL}/report-service/api/v1/report/total-available-shipments-at-hub-clickable`,
  DOWNLOAD_TOTAL_AVAILABLE_SHIPMENTS_CLICKABLE: `${reportURL}/report-service/api/v1/report/total-available-shipments-at-hub-clickable/download`,
  GET_BUSINESS_STATISTICS_CURRENT_MONTH: `${reportURL}/report-service/api/v1/dashboard/business-statistics/current-month`,
  GET_ZONE_WISE_DATA: `${reportURL}/report-service/api/v1/dashboard/zonewisedata`,
  GET_ZONE_HUB_CP_DATA: `${reportURL}/report-service/api/v1/dashboard/zone-hub-cp-data`,
  REFRESH_CACHE_HUBOPS_DATA: `${reportURL}/report-service/api/v1/dashboard/refresh-cache/hubops-data`,
  REFRESH_CACHE_BUSINESS_STATISTICS_PREVIOUS_DAY: `${reportURL}/report-service/api/v1/dashboard/refresh-cache/business-statistics-previous-day`,
  REFRESH_CACHE_BUSINESS_STATISTICS_CURRENT_MONTH: `${reportURL}/report-service/api/v1/dashboard/refresh-cache/business-statistics-current-month`,

  DASHBOARD_COUNT_NEW: `${reportURL}/report-service/api/v1/report/dashboard-count`,
  BULK_TRACKING_UPLOAD: `${reportURL}/report-service/api/bulk/download`,

  GET_OUTSCAN_PENDING_INSCAN_TO_HUB_CLICKABLE: `${reportURL}/report-service/api/v1/report/outscan-pending-inscan-to-hub-clickable`,
  DOWNLOAD_OUTSCAN_PENDING_INSCAN_TO_HUB_CLICKABLE: `${reportURL}/report-service/api/v1/report/outscan-pending-inscan-to-hub-clickable/download`,

  // Shipment Inscanned v/s Weight Audited Adherence Report
  SHIPMENT_INSCANNED_VS_WEIGHT_AUDITED: `${reportURL}/report-service/api/v1/report/shipment-inscan-vs-weight-audited`,
  SHIPMENT_INSCANNED_VS_WEIGHT_AUDITED_DOWNLOAD: `${reportURL}/report-service/api/v1/report/shipment-inscan-vs-weight-audited/download`,

  GET_INBOUND_PENDENCY_CLICKABLE: `${reportURL}/report-service/api/v1/report/inbound-pendency-clickable`,
  DOWNLOAD_INBOUND_PENDENCY_CLICKABLE: `${reportURL}/report-service/api/v1/report/inbound-pendency-clickable/download`,

  // RTO Shipment with Reason Report
  GET_RTO_WITH_REASON_REPORT: `${reportURL}/report-service/api/v1/report/rto-with-reason`,
  DOWNLOAD_RTO_WITH_REASON_REPORT: `${reportURL}/report-service/api/v1/report/rto-with-reason/download`,

  // Outscan Pending Inscan To CP Clickable
  GET_OUTSCAN_PENDING_INSCAN_TO_CP_CLICKABLE: `${reportURL}/report-service/api/v1/report/outscan-pending-inscan-to-cp-clickable`,
  DOWNLOAD_OUTSCAN_PENDING_INSCAN_TO_CP_CLICKABLE: `${reportURL}/report-service/api/v1/report/outscan-pending-inscan-to-cp-clickable/download`,



  GET_ESCALATION_MATRIX: baseURL + "/v1/escalation-matrix",
  // Report Config Manager
  REPORT_CONFIG_LIST: `${reportURL}/report-service/api/v1/report-config`,
  REPORT_CONFIG_UPSERT: `${reportURL}/report-service/api/v1/report-config/upsert`,
  REPORT_CONFIG_PATCH: `${reportURL}/report-service/api/v1/report-config`,         // PATCH /{key}
  REPORT_CONFIG_TOGGLE_ACTIVE: `${reportURL}/report-service/api/v1/report-config`, // PATCH /{key}/toggle-active
  REPORT_CONFIG_DELETE: `${reportURL}/report-service/api/v1/report-config`,        // DELETE /{key}
  REPORT_CONFIG_UI_SCHEMA: `${reportURL}/report-service/api/v1/report-config`,    // GET /{key}/ui-schema
  // Dynamic data engine
  DYNAMIC_REPORT_DATA: `${reportURL}/report-service/api/v1/dynamic-data`,        // GET /{key}?page=&size=&...filters
  DYNAMIC_REPORT_DOWNLOAD: `${reportURL}/report-service/api/v1/dynamic-report`,  // GET /{key}/download

  // LCR Tally Historical and Refresh URLs
  LCR_TALLY_HISTORICAL_DOWNLOAD: `${reportURL}/report-service/api/v1/dynamic-report/lcr_tally_report_historical_data/download`,
  LCR_TALLY_REFRESH_SCHEDULE: `${reportURL}/report-service/api/v1/dynamic-data/refresh-schedule-hubops-reports`,

  // Mark Shipment as Lost / Damaged
  MARK_SHIPMENT_LOST_DAMAGE: baseURL + "/audit-service/v1/audit/terminal-status/bulk",
};
export default urls;
